const plantsPath = "plants";
export const PLANTS = [
    {
        "image" : "./" + plantsPath + "/dragon-tail.jpg",
        "nickname" : "Puff",
        "commonName" : "Dragon's Tail",
        "scientificName" : "Rhaphidophora Decursiva",
        "notes" : "Looked cool"
    },
    {
        "image" : "./" + plantsPath + "/itchy.png",
        "nickname" : "Itchy",
        "commonName" : "Wild Strawberry",
        "scientificName" : "Fragaria nipponica (?)",
        "notes" : "RIP Itchy. Raised from seeds imported from Japan. Truly a joy to see the first sprouts and slow and steady growth. My first death. Left alone over a weekend away. My heart was crushed - you will never be forgotten."
    },
    {
        "image" : "./" + plantsPath + "/pierre.jpg",
        "nickname" : "Pierre",
        "commonName" : "Never Never Plant",
        "scientificName" : "Ctenanthe setosa",
        "notes" : "Currently chilling in my bathroom where he enjoys all the nice humidity after showers. Had a bit of a rough winter, but has been revived and slowly recovering again"
    },
    {
        "image" : "./" + plantsPath + "/sasha-vine.jpg",
        "nickname" : "Sasha",
        "commonName" : "Heartleaf Philodendron",
        "scientificName" : "Philodendron hederaceum",
        "notes" : "Can't decide if I want her to grow upwards or hang down. Also been struggling to find a good spot with ample amounts of light, hence why the newer leaves colours look a bit off."
    },
]